import { render, staticRenderFns } from "./analytics-web-chat.vue?vue&type=template&id=504f9e47&scoped=true&"
import script from "./analytics-web-chat.vue?vue&type=script&lang=js&"
export * from "./analytics-web-chat.vue?vue&type=script&lang=js&"
import style0 from "./analytics-web-chat.vue?vue&type=style&index=0&id=504f9e47&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504f9e47",
  null
  
)

export default component.exports